import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DoctorsService } from 'src/app/shared/doctor-service/doctors.service';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { take } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DoctypeService } from 'src/app/shared/doctortype-service/doctype-service/doctype.service';
import { SelectItem } from 'primeng/api/selectitem';
import * as moment from 'moment';
import { UrlModal } from 'src/app/shared/url.model';
import { MessageService } from 'primeng/api';
import { Message } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { SocketsService } from 'src/app/shared/socket/sockets.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers: [ConfirmationService, MessageService],
})
export class ProfileComponent implements OnInit {
  position: string;
  userToken: string;
  id: string;
  clinicData;
  date4;
  holForm: FormGroup;
  ledddata: FormGroup;
  addreceptionistform: FormGroup;
  profileImage: any;
  type: string;
  holidayData = [];
  newcdForm;
  doctordata :any;
  clinicArray = [];
  @ViewChild('closebutton', { static: false }) pRef: ElementRef;
  @ViewChild('closeclinicmodal', { static: false }) sRef: ElementRef;
  @ViewChild('servicebutton', { static: false }) serRef: ElementRef;
  @ViewChild('closenewclinicbutton', { static: false }) nwRef: ElementRef;
  @ViewChild('holidaybutton', { static: false }) holRef: ElementRef;
  @ViewChild('closedeleteholiday', { static: false}) dholRef: ElementRef;
  @ViewChild('closerecption',{static:false}) bRef:ElementRef
  dropdownList = [];
  degrees: SelectItem[];
  clinicDays: SelectItem[];
  degreeArray: string[] = [];
  isLoading = false;
  docData: any;
  clinicdat:any;
  svForm: FormGroup;
  rdForm: FormGroup;
  led:any;
  cdForm: FormGroup;
  doctorTypeAray = [];
  servicesArray = [];
  texts: string[] = [];
  clinicImagesArray = [];
  uploadedFiles: any[] = [];
  token: string;
  clinicId: any;
  selectedfile: File;
  selectedImageUrl:any;
  deleteholiday: any;
  deletrecept:any;
  ledId:any;
  add:boolean=false;
  timeStamp: any;
  clinicChange:any;
  showdata:any;
  constructor(
    private toast: ToastModule,
    private confirmationdailog: ConfirmDialogModule,
    private confirmationService: ConfirmationService,
    private doctorService: DoctorsService,
    private authService: AuthService,
    private doctorTypeService: DoctypeService,
    private messageService: MessageService,
    private socketService: SocketsService
  ) {}

  ngOnInit() {
    this.authService.authDataSubject.pipe(take(1)).subscribe((res) => {
      (this.id = res._id), (this.token = res._token);
    });
    this.authService.authDataSubject.pipe(take(1)).subscribe((authData) => {
      this.userToken = authData._token;
      this.id = authData._id;
      this.type = authData._type;
    });
    this.degrees = [
      { label: 'MBBS', value: { name: 'MBBS' } },
      { label: 'BDS', value: { name: 'BDS' } },
      { label: 'MD', value: { name: 'MD' } },
      { label: 'BSC Nursing', value: { name: 'BSC Nursing' } },
      { label: 'B.Pharmacy', value: { name: 'B.Pharmacy' } },
    ];
    this.clinicDays = [
      { label: 'Sunday', value: { name: 'Sunday' } },
      { label: 'Monday', value: { name: 'Monday' } },
      { label: 'Tuesday', value: { name: 'Tuesday' } },
      { label: 'Wednesday', value: { name: 'Wednesday' } },
      { label: 'Thursday', value: { name: 'Thursday' } },
      { label: 'Friday', value: { name: 'Friday' } },
      { label: 'Saturday', value: { name: 'Saturday' } },
    ];
    this.authService.authDataSubject.pipe(take(1)).subscribe((authData) => {
      this.userToken = authData._token;
      this.id = authData._id;
      // console.log(this.id);
    });

    this.getAllservice();
    this.oninitForm();
    this.oninitNewClinic();
    this.oninitClinicForm();
    this.getDocType();
    this.getSingleDoctor();
    this.gelAllClinic();
    this.ledddata= new FormGroup({
      pass : new FormControl(null,Validators.required),
      clinicId:new FormControl(null,Validators.required)
    })
    
  }
 onclinicchange(index:any){
  console.log("this is docdata", this.docData);
    this.clinicChange = this.docData.clinicId[index]._id;
    console.log("this is clinicchange", this.clinicChange);
    this.getreceptionist();
  }
  onfilechange(event) {
    this.selectedfile = <File>event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.onload = e => this.selectedImageUrl = reader.result;

      reader.readAsDataURL(file);
      this.showupload();
  }
    console.log('ProfileImage', this.selectedfile);
  }
  cencleuploade(){
    document.getElementById("uploadig").style.display=" none";
    document.getElementById("selectimage").style.display = "inline";
    document.getElementById("cencleupload").style.display ="none";
  }

  onSubmitProfile() {
    this.isLoading = true;
    console.log('profileDP');
    this.doctorService
      .updateprofileImage(this.token, this.clinicId, this.selectedfile)
      .subscribe((res) => {
        this.gelAllClinic();
        this.isLoading = false;
        this.getSingleDoctor();
        console.log('profile uploded');
        this.socketService.sendprofileupdate();

        document.getElementById("cencleupload").style.display = "none";
        document.getElementById('selectimage').style.display = 'inline';
        document.getElementById("uploadimg").style.display = "none";
      });
  }
  showupload() {
    document.getElementById("cencleupload").style.display = "block";
    document.getElementById('selectimage').style.display = 'none';
    document.getElementById("uploadimg").style.display = "block";
  }
  gelAllClinic() {
    this.doctorService
      .getAllClinic(this.id, this.userToken)
      .subscribe((res) => {
        this.clinicArray = res.clinics;
        this.clinicData = this.clinicArray[0];
        this.clinicImagesArray = this.clinicData.clinicImages.map((sinImg) => {
          return UrlModal._URL + '/' + sinImg;
        });
        this.getHolidays();

        // console.log(this.clinicImagesArray);
        this.oninitClinicForm();
      });
  }

  onChangeClinic(index) {

    this.clinicData = this.clinicArray[index];
    this.clinicImagesArray = this.clinicData.clinicImages.map((sinImg) => {
      return UrlModal._URL + '/' + sinImg;
    });
    this.oninitClinicForm();
    this.getHolidays();
  }

  getHolidays() {
    this.doctorService
      .getHolidays(this.userToken, this.clinicData._id)
      .subscribe((res) => {
        this.holidayData = res;
        // console.log("this is holiday",this.holidayData[0]._id)
      });
  }
  deleteHoliday(){
    var payload={
      holidayId:this.holidayData[0]._id
    }
    console.log('holiid',this.clinicId)
    this.doctorService.deleteholi(this.token, payload).subscribe(res =>{

      // this.deleteholiday.clinicId=res
      this.getHolidays();
      
    });
    this.dholRef.nativeElement.click();
  }
  OnSubmitHoliday() {
    this.isLoading = true;
    this.doctorService
      .saveHol(this.userToken, this.holForm.value, this.clinicData._id, this.id)
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'success',
            detail: 'you successfully marked the holiday',
          });
          this.holRef.nativeElement.click();
          this.getHolidays();
          console.log("this is holiday data",this.holidayData);
        },
        (error) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'warning',
            summary: 'failed',
            detail: 'failed to marked the holiday ',
          });
        }
      );
      
  }

  oninitNewClinic() {
    this.newcdForm = new FormGroup({
      weekDays: new FormControl(null, Validators.required),
      clinicName: new FormControl(null, Validators.required),
      patientLimit: new FormControl(null, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
        Validators.required,
      ]),
      startTime: new FormControl(null, Validators.required),
      endTime: new FormControl(null, Validators.required),
      line1: new FormControl(null, Validators.required),
      city: new FormControl(null, Validators.required),
      district: new FormControl(null, Validators.required),
      pincode: new FormControl(null, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
        Validators.required,
      ]),
      state: new FormControl(null, Validators.required),
    });
  }
  getAllservice() {
    this.doctorTypeService.getAllServices(this.userToken).subscribe((res) => {
      res.doctorService.forEach((ser) => {
        this.dropdownList.push(ser.serviceName);
      });
    });
  }

  onSubmitServiceData() {
    const name = this.rdForm.value['services'];
    this.isLoading = true;
    console.log(this.texts);
    this.doctorService
      .updateDoctorServiceToDatabase(this.texts, this.id, this.userToken)
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'success',
            detail: 'you successfully added the service ',
          });
          this.serRef.nativeElement.click();
          this.getSingleDoctor();
          this.gelAllClinic();
        },
        (error) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'warning',
            summary: 'failed',
            detail: 'failed to add the service ',
          });
          this.getSingleDoctor();
          this.gelAllClinic();
        }
      );
    this.getSingleDoctor();
    this.gelAllClinic();
  }

  getdoctordata(){
    this.doctorService.getSingleDoctorFromDb(this.id, this.userToken).subscribe((res:any)=>{
      this.doctordata = res;
      this.getclinicwifi();
    });
  }

  getclinicwifi(){
    this.doctorService.getdocled(this.clinicChange, this.userToken).subscribe((res:any)=>{
      console.log("this is led data",res);
      this.led = res
      console.log("this is led data@@",res);
      this.ledId = res.data[0]._id
      this.ledddata= new FormGroup({
        pass : new FormControl(res.data[0].pass,Validators.required),
        clinicId:new FormControl(null,Validators.required)
      });
    });
  }

  updateLed(){
    let payload = {
      clinicId: this.clinicChange,
      pass:this.ledddata.value['pass'],
      id :this.ledId
    }
    this.doctorService.updateLed(payload,this.userToken).subscribe((res:any)=>{
      console.log("successfully updated",res)
      // alert("successfully updated");
    })
  }
  
  getSingleDoctor() {
    console.log("single doctors is here")
    if(this.type == 'DOCTOR'){this.doctorService.getSingleDoctorFromDb(this.id, this.userToken).subscribe(
      (res) => {
        this.docData = res;
        console.log("this is doctor", this.docData);
        this.onclinicchange(0);
        this.docData.experience = this.docData.experience
          ? this.docData.experience
          : 0;
        this.profileImage = 'https://api.doqmatokens.com/' + res.profileImage;
        if (res.services.length > 0) {
          this.texts = res.services;
          this.servicesArray = res.services;
        }
      },
      (error) => {
        console.log('error');
      }
    );
  }else {
    this.doctorService.getSinglereceptionist(this.id, this.userToken).subscribe(
      (res) => {
        this.docData = res;
        console.log("this is doctor", this.docData);
        this.docData.experience = this.docData.experience
          ? this.docData.experience
          : 0;
        this.profileImage = 'https://api.doqmatokens.com/' + res.profileImage;

        if (res.services.length > 0) {
          this.texts = res.services;
          this.servicesArray = res.services;
        }
      },
      (error) => {
        console.log('error');
      }
    );
  }
  }
  oninitForm() {
    const name = this.docData ? this.docData.name : null;
    const email = this.docData ? this.docData.email : null;
    const experience = this.docData ? this.docData.experience : 0;
    const degree = this.docData ? this.docData.degree : null;
    const doctorType = this.docData ? this.docData.doctorType._id : null;
    const district = this.docData ? this.docData.district : null;

    const consultationFee = this.docData
      ? this.docData.consultationFee.firstVisit
      : 0;

    const line1 = this.docData ? this.docData.address.line1 : null;
    const city = this.docData ? this.docData.address.city : null;
    const pincode = this.docData ? this.docData.address.pincode : null;
    const state = this.docData ? this.docData.address.state : null;

    const clinic = this.docData ? this.docData.clinic : null;
    const phoneNo = this.docData ? this.docData.phoneNo : null;

    this.rdForm = new FormGroup({
      name: new FormControl(name),
      doctorType: new FormControl(doctorType),
      email: new FormControl(email, [Validators.email]),
      password: new FormControl(null),
      degree: new FormControl(null),
      gender: new FormControl(null),
      consultationFee: new FormControl(
        consultationFee,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/)),
      experience: new FormControl(
        experience,
        Validators.pattern(/^-?(0|[1-9]\d*)?$/)
      ),

      line1: new FormControl(line1),
      city: new FormControl(city),
      district: new FormControl(district),
      pincode: new FormControl(pincode, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
      state: new FormControl(state),

      clinic: new FormControl(clinic),
      phoneNo: new FormControl(phoneNo, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
        Validators.minLength(10),
      ]),
    });

    this.svForm = new FormGroup({
      services: new FormControl(null, Validators.required),
    });

    this.holForm = new FormGroup({
      startDate: new FormControl(null, Validators.required),
      endDate: new FormControl(null, Validators.required),});
    this.addreceptionistform=new FormGroup({
      name:new FormControl(null, Validators.required),
      password:new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      phoneNo: new FormControl(null, Validators.required),
      clinicId: new FormControl(null),
    })
  }
  onSubmit() {
    this.isLoading = true;
    const name = this.rdForm.value['name'];
    const doctorType = this.rdForm.value['doctorType'];
    const email = this.rdForm.value['email'];
    let degree = this.rdForm.value['degree'];
    const experience = this.rdForm.value['experience'];
    const consultationFee = this.rdForm.value['consultationFee'];

    const district = this.rdForm.value['district'];

    const line1 = this.rdForm.value['line1'];
    const city = this.rdForm.value['city'];
    const pincode = this.rdForm.value['pincode'];
    const state = this.rdForm.value['state'];

    const clinic = this.rdForm.value['clinic'];
    if (degree && degree.length > 0) {
      degree = degree.map((sinDeg) => {
        return sinDeg.name;
      });
    }

    // console.log(degree);
    this.doctorService
      .updateDoctorToDatabase(
        name,
        doctorType,
        email,
        experience,
        degree,
        line1,
        city,
        +pincode,
        state,
        clinic,

        this.userToken,
        this.id,
        consultationFee,
        district
      )
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'success',
            detail: 'you successfully updated ur profile ',
          });
          this.getSingleDoctor();
          this.pRef.nativeElement.click();
          console.log(
            'this is doctor profile data',
            name,
            'doctor type',
            doctorType,
            'email',
            email,
            'experience',
            experience,
            'degree',
            degree,
            'line1',
            line1,
            'city',
            city,
            'pincode',
            +pincode,
            'state',
            state,
            'clinic',
            clinic,
            'token',

            this.userToken,
            'id',
            this.id,
            'consultationfee',
            consultationFee,
            'district',
            district
          );
        },
        (error) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'warning',
            summary: 'failed',
            detail: 'failed to aupdate the profile ',
          });
        }
      );
  }
  getDocType() {
    this.doctorTypeService.getDocType(this.userToken).subscribe((res) => {
      if (res && res.length > 0) {
        res.forEach((singleElem) => {
          this.doctorTypeAray.push({
            name: singleElem.name,
            id: singleElem._id,
          });
        });
      }
    });
  }
  editClinic(clinicData) {
    console.log(clinicData);
  }

  oninitClinicForm() {
    const patientLimit = this.clinicData ? this.clinicData.patientLimit : null;
    const city = this.clinicData ? this.clinicData.address.city : null;
    const state = this.clinicData ? this.clinicData.address.srate : null;
    const district = this.clinicData ? this.clinicData.address.district : null;
    const pincode = this.clinicData ? this.clinicData.address.pincode : null;
    const line1 = this.clinicData ? this.clinicData.address.line1 : null;

    const clinicName = this.clinicData ? this.clinicData.clinicName : null;

    //const startTime = this.clinicData ? this.clinicData.timming.startTime : null;
    //  const endTime = this.clinicData ? this.clinicData.timming.endTime : null;

    this.cdForm = new FormGroup({
      clinicName: new FormControl(clinicName),

      line1: new FormControl(line1),
      city: new FormControl(city),
      district: new FormControl(district),
      pincode: new FormControl(pincode, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
      state: new FormControl(state),
      weekDays: new FormControl(null),

      patientLimit: new FormControl(patientLimit, [
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
      startTime: new FormControl(null),
      endTime: new FormControl(null),
    });
  }
  onSubmitClinicData() {
    this.isLoading = true;
    const patientLimit = this.cdForm.value['patientLimit'];
    let workingweekDays = this.cdForm.value['weekDays'];
    let startTime = this.cdForm.value['startTime'];
    let endTime = this.cdForm.value['endTime'];
    const clinicName = this.cdForm.value['clinicName'];
    const district = this.cdForm.value['district'];

    const line1 = this.cdForm.value['line1'];
    const city = this.cdForm.value['city'];
    const pincode = this.cdForm.value['pincode'];
    const state = this.cdForm.value['state'];
    if (workingweekDays && workingweekDays.length > 0) {
      workingweekDays = workingweekDays.map((day) => {
        return day.name;
      });
    }
    this.doctorService
      .setClinicData(
        workingweekDays,
        patientLimit,
        this.clinicData._id,
        startTime,
        endTime,
        clinicName,
        district,
        line1,
        city,
        pincode,
        state,
        this.userToken
      )
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'success',
            detail: 'you successfully update the clinic data ',
          });
          // this.getSingleDoctor();
          this.gelAllClinic();
          this.sRef.nativeElement.click();
        },
        (error) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'warning',
            summary: 'failed',
            detail: 'failed to update the clinic ',
          });
        }
      );
  }
  displayval:string='';
  getvalue(val:string)
  {
    console.warn(val)
    this.displayval=val
  }
  search($events) {
    this.dropdownList = this.dropdownList.slice();
  }
  onKeyUp(event) {
    if (event.key == 'Enter') {
      let tokenInput = event.srcElement as any;
      if (tokenInput.value) {
        this.texts.push(tokenInput.value);
        tokenInput.value = '';
      }
    }
  }

  getreceptionist(){
    this.doctorService.getreceptionist(this.token,this.clinicChange).subscribe((res:any)=>{
      console.log(res,"this data")
      this.showdata = res.receptionist;
      // this.clinicdat = res._id;
      // console.log("this is clinic id",res._id);
        this.add= false;
    },(err)=>{
      if(err.message="not receptionist available"){
        this.add= true;
      }
    })
  }
  deleterecept(recep_id:any) {
    this.doctorService.onDeleterecept(this.clinicChange,recep_id,this.token).subscribe(res => {
        this.gelAllClinic();
        console.log('delet success', res);
        this.getreceptionist();
      });
  }
  
  addreceptionist(){
    this.addreceptionistform.value.clinicId = this.clinicChange;
    this.doctorService.addreceptionist(this.addreceptionistform.value,this.token).subscribe(
    (res) => {
      console.log("user added",res);
      this.getreceptionist();
      this.bRef.nativeElement.click();
    },(error)=>{
      console.log("this is error",error);
    })
  }
  onSubmitnewClinicData() {
    this.isLoading = true;
    let workingweekDays = this.newcdForm.value['weekDays'];

    if (workingweekDays && workingweekDays.length > 0) {
      workingweekDays = workingweekDays.map((day) => {
        return day.name;
      });
    }

    const newClinicData = {
      ...this.newcdForm.value,
      weekDays: workingweekDays,
      doctorId: this.id,
    };
    if (this.newcdForm.valid) {
      this.doctorService.AddnewClinic(newClinicData, this.userToken).subscribe(
        (res) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'success',
            detail: 'you successfully added the clinic ',
          });
          this.serRef.nativeElement.click();
        },
        (error) => {
          this.isLoading = false;
          this.messageService.add({
            key: 'tc',
            severity: 'warning',
            summary: 'failed',
            detail: 'failed to add the clinic ',
          });
        }
      );
    } else {
      this.isLoading = false;
      alert('All field are required');
    }
  }
}